import { render } from "./PagamentiDataTable.vue?vue&type=template&id=47f2b481"
import script from "./PagamentiDataTable.vue?vue&type=script&lang=js"
export * from "./PagamentiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__